import { createLogic } from 'redux-logic';
import { AuthMethod, LEGACY_WIDGET_AUTH_METHOD } from 'config/constants';
import { FLAG_OAUTH_ENABLED } from 'config/env';
import { getGatekeeperTokenForBooking } from 'lib/gatekeeperApi';
import { getBookingAuthMethod } from 'lib/graphql';
import { qffAuthInit } from 'lib/qffAuth';
import * as authenticationActions from '../actions';
import * as sbaActions from '../sba/actions';

const getAuthMethod = ({ data }) => {
  if (data.authMethod === LEGACY_WIDGET_AUTH_METHOD) {
    return FLAG_OAUTH_ENABLED ? AuthMethod.OAUTH : AuthMethod.WIDGET;
  }

  return data.authMethod;
};

const retrieveBookingAuthenticationMethod = createLogic({
  type: authenticationActions.retrieveBookingAuthMethod,
  async process({ action, client }, dispatch, done) {
    const { bookingId } = action.payload;

    const result = await getBookingAuthMethod(client, {
      variables: { bookingId },
      fetchPolicy: 'cache-first',
    });
    const authMethod = getAuthMethod(result);

    dispatch(authenticationActions.updateAuthMethod({ authMethod }));

    if (authMethod === AuthMethod.SBA) {
      const token = getGatekeeperTokenForBooking(bookingId);
      dispatch(sbaActions.updateSBAAuthentication({ token }));
      dispatch(authenticationActions.updateFetchBookingAuthProcess({ done: true }));
    } else if (authMethod === AuthMethod.WIDGET) {
      // TODO: Should updateFetchBookingAuthProcess be dispatched for widget auth as well?
      qffAuthInit();
    } else if (authMethod === AuthMethod.OAUTH) {
      dispatch(authenticationActions.updateFetchBookingAuthProcess({ done: true }));
    }

    // TODO: Catch "unknown" auth types (would usually indicate 404 - i.e. booking not found)

    done();
  },
});

export default retrieveBookingAuthenticationMethod;
